<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="500px">
    <v-card flat>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Pilih Tujuan Kelompok Pendampingan</v-toolbar-title>
        <v-spacer />
        <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-container>
        <base-table-header @search="onSearch" @reload="onReload">
          <template v-slot:subtitle>
            <div class="mt-4 subtitle-1 black--text"> {{ total }} Kelompok </div>
          </template>
        </base-table-header>
        <div style="height: 350px; overflow: scroll">
          <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
            <template slot-scope="{ item }">
              <td>
                <v-card flat class="ma-0">
                  <v-list-item dense class="px-0" :disabled="+kpPaId === +item.id" @click="onSelectKelompok(item)">
                    <v-list-item-content>
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="secondary">
                          <v-icon dark>mdi-hospital-building</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0">
                          <v-row no-gutters>
                            <v-col cols="12" sm="12" :md="+kpPaId === +item.id ? 8 : 12" class="my-auto">
                              <h2 class="body-1 secondary--text">{{ $getDeepObj(item, 'nama') || '-' }}</h2>
                              <p class="body-2">
                                <span class="info--text">
                                  {{ ($getDeepObj(item, 'psp_kp_pa_sekolahs.data') || []).length }}
                                </span>
                                Sekolah Anggota <br />
                              </p>
                            </v-col>
                            <v-col cols="12" sm="12" md="4" class="my-auto" v-if="+kpPaId === +item.id">
                              <v-chip small class="red white--text mr-1">
                                Kelompok Asal
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </td>
            </template>
          </base-list-table>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import list from '@mixins/list';
import { mapActions } from 'vuex';
export default {
  mixins: [list],
  props: {
    kpPaId: {
      type: Number,
      default: null,
    },
    gelombang: {
      type: [Number, String],
      default: 2,
    },
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
    };
  },

  methods: {
    ...mapActions('diklatPa', ['fetch']),

    fetchData() {
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {}, {
        gelombang: this.gelombang,
      });
      this.fetch({ params: params }).then(({ data, meta }) => {
        this.data = data || [];
        this.total = meta?.total || 0;
        this.pageTotal = meta?.last_page || 1;
        this.params.limit = meta?.per_page || this.params.limit;
      });
    },

    open() {
      this.dialog = true;
      this.fetchData();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSelectKelompok(item) {
      this.resolve(item);
      this.dialog = false;
    },
  },
};
</script>
